<template>
<div>
  <div class="about-us">
    <el-container class="d-flex-column">
      <el-row :gutter="24">
        <el-col :span="12">&nbsp;</el-col>
        <el-col :span="12">
          <h1>About Us</h1>
          <p>We are Maren Solutions, one of the bespoke in-house software development company backed by Saudi’s leading Business Group. We design intelligent, cost-effective and intuitive web applications, desktop applications and mobile apps that help streamline process for new businesses</p>
          <!-- <a href="javascript:void(0);">Read more</a> -->
        </el-col>
      </el-row>
    </el-container>
  </div>
    <el-container class="d-flex-column p-tb50">
      <el-row :gutter="20">
        <el-col :span="24">
          <h2>Our Methodology</h2>
          <p>We adopt customised agile methodology with <span class="d-block">scrum practice which nourishes our products to be</span> implemented within stiplulated time.</p>
        </el-col>
      </el-row>
    </el-container>
  <div class="maren-believe">
    <el-container class="d-flex-column">
      <el-row :gutter="30">
        <el-col :span="14">
          <h2>We believe that we can <span class="d-block">add value in the below ways:</span></h2>
          <ul class="maren-believe-list">
            <li>Quick-ramp-up to understand the product due to domain knowledge within Maren</li>
            <li>Ability to participate and even lead requirement analysis for domains we have expertise in.</li>
            <li>Creating delivery roadmap to meet  product requirements.</li>
            <li>Utilize our talent pool to work with cutting-edge technologies.</li>
            <li>Analytical QA team to deliver bug-free products.</li>
            <li>Ability to adopt agile development methodologies to work with changing business needs and providing visibility with short development cycles with more frequent milestones</li>
            <li>Provide support post deployement of our products</li>
          </ul>
        </el-col>
        <el-col :span="10" class="text-right">
          <img src="../../../public/img/aboutus/methedology.png" class="img-responsive" alt="Believe">
        </el-col>
      </el-row>
    </el-container>
  </div>
  <el-container class="d-flex-column">
    <div class="p-tb100 d-flex-j-a-center">
      <div class="p-dev-outer">
        <div class="p-dev">
          <span class="p-dev-tit">Product <span class="d-block">Development</span></span>
        </div>
      </div>
      <ul class="prod-list">
        <li>Requirement Planning</li>
        <li class="yellow">Analysis</li>
        <li class="pink">Design</li>
        <li class="dark-blue">Review & Approval</li>
        <li class="ciyan">Coding</li>
        <li class="purple">QA</li>
        <li class="blue">Go Live & Support</li>
      </ul>
    </div>
  <hr />
    <div class="core-values">
            <h2>Our Core Values</h2>
            <el-row :gutter="30" class="careers-grid">
                <el-col :span="8">
                    <el-card shadow="never" class="core-bg">
                        <h4>Continue to grow</h4>
                        <p>We keep learning, teaching, and growing individually, as a company and as a community.</p>                    
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" class="core-bg bg-white">
                        <h4>Lead with passion</h4>
                        <p>We love what we do and we do what we love. We are driven, take ownership for our work, and hold each other responsible.</p>                    
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" class="core-bg">
                        <h4>Positive vibes</h4>
                        <p>We are positive, respectful team players. We build each other up, and are always ready to go the extra mile to help one another. </p>                    
                    </el-card>
                </el-col>
            </el-row>
        </div>
  </el-container>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
    scobj:{
      immediate:true,
      deep: true,
      handler(){
        if(this.scobj){
          this.scobj = false
          var element = this.$refs['flightRef'];
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }
      }
    }
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
          scobj: false,
          sobj: {}
        }
      },
        async created() {
    let response = await this.$store.dispatch("FETCH_SSC", this);
localStorage.setItem('FTR', JSON.stringify(response.FTR)),
localStorage.setItem('FTD', JSON.stringify(response.FTD))
  },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'aboutus');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'aboutus');
        }
    };
</script>


// WEBPACK FOOTER //
// Aboutus.vue